import type { StoryRow } from '@/api/stories'

const PROVIDERS: Record<string, string> = { agy: 'Antigravity', cli: 'Claude CLI', gemini: 'Gemini', mock: 'Mock' }

export function storyModelLabel(story: Pick<StoryRow, 'generation_models' | 'generation_provider' | 'generation_origin'>): string {
  const models = [...new Set(story.generation_models ?? [])].join(', ')
  if (story.generation_origin === 'editorial') return models ? `Editorially repaired · ${models}` : 'Editorially repaired'
  if (story.generation_origin === 'mixed') return models ? `AI + editorial · ${models}` : 'AI + editorial · model not recorded'
  if (!models) return 'Model not recorded'
  if (models === 'mock') return 'Mock generation'
  const provider = story.generation_provider && (PROVIDERS[story.generation_provider] ?? story.generation_provider)
  return `${provider || 'Model'} · ${models}`
}

export function StoryModelLabel({ story, id }: { story: StoryRow; id?: string }) {
  const label = storyModelLabel(story)
  return <span id={id} className="block break-words text-xs text-ink-3" title={label} data-testid="story-model">{label}</span>
}
